// #region imports

// --- Angular
import { trigger, transition, style, animate } from '@angular/animations';

// #endregion

export const cookiePolicyAnimation = trigger('cookiePolicyAnimation', [
  transition(':enter', [
    style({ transform: 'translateY(50%)', opacity: 0 }),
    animate('200ms', style({ transform: 'translateY(0%)', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)', opacity: 1 }),
    animate('200ms', style({ transform: 'translateY(50%)', opacity: 0 }))
  ]),
]);
